import React, { useState, lazy } from 'react';
import { deriveMark } from './helpers';
interface CompanyMarkProps {
  company: string;
  mark?: string;
  domain?: string;
  logo?: string;
}
/** Keyless logo sources tried in order (Clearbit shut down Dec 2025). */
function logoSources(domain: string): string[] {
  return [`https://logos.hunter.io/${domain}`, `https://logo.debounce.com/${domain}`, `https://icons.duckduckgo.com/ip3/${domain}.ico`];
}
/**
 * A refined company badge in a curved square. When a `domain` is provided we
 * pull the real brand logo from keyless logo services, trying each in turn.
 * If every source fails, we fall back to the Fraunces lettermark so the layout
 * never breaks and stays cohesive with the editorial aesthetic.
 */
export function CompanyMark({
  company,
  mark,
  domain,
  logo
}: CompanyMarkProps) {
  // An explicit logo URL takes priority, then keyless domain-based sources.
  const sources = [...(logo ? [logo] : []), ...(domain ? logoSources(domain) : [])];
  const [srcIndex, setSrcIndex] = useState(0);
  const letters = (mark ?? deriveMark(company)).slice(0, 3);
  const size = letters.length >= 3 ? 'text-[10px]' : letters.length === 2 ? 'text-[12px]' : 'text-[15px]';
  const currentSrc = sources[srcIndex];
  return <span aria-hidden="true" className="flex h-11 w-11 shrink-0 select-none items-center justify-center overflow-hidden rounded-[10px] border border-[var(--line-strong)] bg-white p-[7px] shadow-[0_1px_0_rgba(26,24,21,0.04)]" data-id="element-56" data-mp="276srb5edt24k">
      {currentSrc ? <img key={currentSrc} src={currentSrc} alt="" loading="lazy" onError={() => setSrcIndex(i => i + 1)} className="h-full w-full object-contain" data-id="element-57" data-mp="1xaz7r228w8da" /> : <span className={`font-display ${size} font-medium tracking-tight text-[var(--ink)]`} data-id="element-58" data-mp="19j1xvgicvqet">
          {letters}
        </span>}
    </span>;
}